import getContextHook from '../contexts/getContextHook';
import { IDMappingDetailsContext } from '../contexts/IDMappingDetails';

export default getContextHook(IDMappingDetailsContext);
